export default "__VITE_ASSET__03df7e80__"